//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageBtns from "@/components/common_pageBtns.vue";
import NavBar from '@/components/common_navBar.vue'
import { setTimeout } from 'timers';
export default {
  data () {
    return {
      qrCodeUrl: '',
      expireDate: '',
      btnConfig: {
        list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1)} ],
      },
      //二维码 0是未激活 ，1是激活
      // ERWEIMA:"0",
      ERWEIMA:"0",
      PR_header:{
        H1_T:"返利计划",
        H1_B:"加入返利计划，获得更多奖励"
      },
    };
  },

  components: {NavBar, PageBtns},

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  async created () {
    if (Object.keys(this.userInfo).length == 0) {
      await this.getMemberInfo()
    }
    // 检查二维码是否已经生成
    await this.checkGenQrCode () 
  },
  methods: {
    async getMemberInfo (fansOpenId, bdOpenId) {
      let {data} = await this.$http({
        url: this.$api.GetMemberInfo,
        method: 'post'
      })
      if(data.state==1) {
        this.$store.commit('set_userInfo', data.data)
      }
    },

    async genQrCode () {
      this.$msg.loading("正在生成二维码");
      let {data} = await this.$http({
        url: this.$api.CreateQr,
        method: 'post',
        data: {
          // brandOpenId: 'b40b214674d443ef9bdca71ffe05b340',
          // userOpenId: '0b9593620f80429083814ebd48f39537',
          brandOpenId: this.userInfo.BrandOpenId,
          userOpenId: this.userInfo.OpenId,
          bindType: 0,
        }
      })
      this.$msg.hideLoading()
      if (data.state == 1) {
        this.$msg.success('生成成功')
        this.qrCodeUrl = data.data.WechatQrUrl
        this.expireDate = data.data.EffectiveDeadline
        this.ERWEIMA = '1'
      }
    },

    checkGenQrCode () {
      this.$msg.loading()
      this.$http({
        url: this.$api.GetQrCodeInfo + `?brandOpenId=${this.userInfo.BrandOpenId}&userOpenId=${this.userInfo.OpenId}&bindType=0`
        // url: this.$api.GetQrCodeInfo + `?brandOpenId=b40b214674d443ef9bdca71ffe05b340&userOpenId=0b9593620f80429083814ebd48f39537&bindType=0`
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.qrCodeUrl = res.data.data.WechatQrUrl
          this.expireDate = res.data.data.EffectiveDeadline
          this.ERWEIMA = '1'
        }
      })
    },

    go_back(){
      this.$router.go(-1);
    },
    go_record(){
      this.$router.push({
        path:"/mMms/Reference/MemberReferenceList"
      })
    }      
  }
}

